import React from 'react';

import CustomSelect, { Option } from './CustomSelect';

const Select = (props) => {
    const { onChange, value, name, options } = props;

    return (
        <CustomSelect selected={value} name={name} onSelect={onChange}>
            {options.map((option, index) => (
                <Option
                    key={index}
                    value={option.value}
                    disabled={option.disabled}
                >
                    {option.name}
                </Option>
            ))}
        </CustomSelect>
    );
};
export default Select;
